// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_EVENT_HANDLER_LIST = 'cluster-import/SET_EVENT_HANDLER_LIST';
export const SET_EVENT_HANDLER_ITEM = 'cluster-import/SET_EVENT_HANDLER_ITEM';
export const UNSET_EVENT_HANDLER_ITEM = 'cluster-import/UNSET_EVENT_HANDLER_ITEM';
export const ADD_EVENT_HANDLER_ITEM = 'cluster-import/ADD_EVENT_HANDLER_ITEM';
export const UPDATE_EVENT_HANDLER_ITEM = 'cluster-import/UPDATE_EVENT_HANDLER_ITEM';
export const SET_EVENT_HANDLER_IS_DELETING = 'cluster-import/SET_EVENT_HANDLER_IS_DELETING';
export const SET_EVENT_HANDLER_IS_LOADING = 'cluster-import/SET_EVENT_HANDLER_IS_LOADING';
export const REMOVE_EVENT_HANDLER_ITEM = 'cluster-import/REMOVE_EVENT_HANDLER_ITEM';